export default () => {
    // Define variables for the font size and its constraints
    // let fontSize = 16; // Starting font size
    const minSize = 12; // Minimum allowable font size
    const maxSize = 20; // Maximum allowable font size

    // Obtain elements from the DOM
    const increaseButton = document.getElementById('increase');
    const decreaseButton = document.getElementById('decrease');

    // Function to adjust font size
    function adjustFontSize(change) {
        const texts = document.querySelectorAll('.js-text-resize'); // All elements with the class name .text
        texts.forEach(function (text) {
            let currentSize = parseInt(window.getComputedStyle(text, null).getPropertyValue('font-size'));
            let newSize = currentSize + change; // Calculate new size
            if (newSize >= minSize && newSize <= maxSize) { // Ensure new size is within bounds
                text.style.fontSize = newSize + 'px'; // Apply new size
            }
        });
    }

    if (increaseButton !== null && decreaseButton !== null) {
        // Event listeners for the buttons
        increaseButton.addEventListener('click', function () {
            adjustFontSize(1);
        }); // Increase font size
        decreaseButton.addEventListener('click', function () {
            adjustFontSize(-1);
        }); // Decrease font size
    }
}
